import { makeHttpRequest } from "@/shared";

import { mapContractToServer } from "./mappers/mapContractToServer";

export const addContract = async (contract) => {
    const response = (
        await makeHttpRequest({
            url: "order",
            method: "POST",
            data: mapContractToServer(contract),
        })
    ).data;

    return response;
};
